import React, { useMemo } from 'react';
import { PreferredIvrLanguage, PreferredIvrLanguageFormType } from '../../CallSettings/CallBarring/utils';
import {useFormikContext} from 'formik';
import {useTranslation} from 'react-i18next';
import { PreferredIvrLanguageFormProps, useStyles } from './PreferredIvrLanguageForm.utils';
import SwitchWithLabel from '../../../SwitchWithLabel/SwitchWithLabel';
import { Grid } from '@material-ui/core';
import SelectField from '../../../SelectField/SelectField';
import IconWithTooltip from '../../../Tooltip/IconWithTooltip';
import classNames from 'classnames';

const PreferredIvrLanguageForm: React.VFC<PreferredIvrLanguageFormProps> = ({
    toolTipKey,
    customClasses
}) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const languageList = useMemo(() => {
        return Object.values(PreferredIvrLanguage)
            .map((v) => ({
                name: t(`enums:ivrLanguage.${v}`),
                value: v,
            }));
    }, []);

    const defaultValue = useMemo(() => {
        return languageList.find(e => e.value === PreferredIvrLanguage.en);
    }, [languageList]);

    const {
        values,
        setFieldValue,
        initialValues
    } = useFormikContext<PreferredIvrLanguageFormType>();

    return (
        <div className={classNames(classes.inputs, customClasses?.root)}>
            <SwitchWithLabel
                className={classes.switchContainer}
                id="preferredIvrLanguageStatus"
                field="preferredIvrLanguageStatus"
                label={t('screens:extensions.preferedIvrLanguage')}
                value={values.preferredIvrLanguageStatus}
                disabled={values.preferredIvrLanguageBlocked}
                setValue={(field, value) => {
                    if(!values.preferredIvrLanguageCode && value === true) {
                        setFieldValue('preferredIvrLanguageCode', defaultValue?.value);
                    } else if(initialValues.preferredIvrLanguageStatus === false && value === false) {
                        setFieldValue('preferredIvrLanguageCode', initialValues.preferredIvrLanguageCode);
                    }
                    setFieldValue(field, value);
                }}
                icon={
                    <IconWithTooltip
                        dataQa="language-tooltip"
                        tooltipText={t('tooltips:extensions.' + toolTipKey)}
                    />
                }
            />
            {values.preferredIvrLanguageStatus && (
                <Grid item className={classes.itemsContainer}>
                    <SelectField
                        label={t('screens:extensions.language')}
                        items={languageList}
                        value={languageList.find(
                            (v) => v.value === values.preferredIvrLanguageCode,
                        )}
                        onChange={(_, value) => {
                            setFieldValue(
                                'preferredIvrLanguageCode',
                                value.value,
                                false,
                            );
                        }}
                        disableClearable
                        dataQa="language-input"
                        getOptionLabel={(v: { name: string }) => v.name}
                        getOptionSelected={(v: {
                            value: PreferredIvrLanguage;
                        }) => v.value === values.preferredIvrLanguageCode}
                        classes={{ container: classes.formatSelect }}
                    />
                </Grid>
            )}
        </div>        
    );
};

export default PreferredIvrLanguageForm;